import {
    Component, ElementRef, EventEmitter, OnInit,
    OnChanges, SimpleChanges, forwardRef, Input, Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

declare var jQuery: any;

const noop = () => {
};

export const CUSTOM_COMBO_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ComboboxComponent),
    multi: true
};


@Component({
    selector: 'app-combobox',
    styleUrls: ['./combobox.scss'],
    templateUrl: './combobox.html',
    host: { '(document:click)': 'closePopup($event)' },
    providers: [CUSTOM_COMBO_CONTROL_VALUE_ACCESSOR]
})
export class ComboboxComponent implements OnInit, OnChanges, ControlValueAccessor {

    @Input() data;
    @Input() dropDownHeight;
    @Input() dropDownWidth;
    @Input() width = '100%';
    @Input() displayMember;
    @Input() valueMember;
    @Input() titleMember: string;
    @Input() serverFiltering = false;
    @Input() placeHolder = 'search';
    @Input() cClass;
    @Input() isForGrid;
    @Input() disabled = false;
    @Input() checkBoxes = false;

    @Output('textChanged') textChanged = new EventEmitter();
    @Output('selectedItemChanged') selectedItemChanged = new EventEmitter();
    @Output('itemCheckChanged') itemCheckChanged = new EventEmitter();

    public selectedValue: any;
    public _onChange: (value: any) => void = noop;
    public onTouchedCallback: () => void = noop;

    public popUpInnerHeight = '200px';
    public fullData: any;
    public showPopup = false;
    public itemText = '';
    public isTouched = false;
    public currentIndex = -1;

    public currentElement: ElementRef;
    constructor(el: ElementRef) {
        this.currentElement = el;
    }

    ngOnInit() {
        if (this.dropDownHeight) {
            this.popUpInnerHeight = this.dropDownHeight;
        }
        if (this.dropDownWidth) {
            this.width = this.dropDownWidth;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('data')) {
            if (this.data) {
                if (!this.serverFiltering) {
                    this.fullData = this.data.slice();
                }
                this.updateText();
            }
        }
    }

    writeValue(value: any) {
        this.selectedValue = value;
        this.updateText();
    }

    registerOnChange(fn: (value: any) => void) {
        this._onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    public updateText() {
        if (this.data && this.selectedValue) {
            if (!Array.isArray(this.selectedValue)) {
                const _the = this;
                const items = this.data.filter(function (item) {
                    return item[_the.valueMember] == _the.selectedValue;
                });
                if (items.length > 0) {
                    this.itemText = items[0][this.displayMember];
                }
            } else {
                if (this.selectedValue.length == 0) {
                    this.itemText = '';
                    this.data.map(function (item) {
                        item.checked = false;
                    });
                } else {
                    if (this.fullData) {
                        for (let i = 0; i < this.fullData.length; i++) {
                            for (let j = 0; j < this.selectedValue.length; j++) {
                                if (this.fullData[i][this.valueMember] == this.selectedValue[j]) {
                                    this.fullData[i].checked = true;
                                }
                            }
                        }
                        this.setCheckedItemText();
                    }
                }
            }
        } else {
            this.itemText = '';
        }
    }

    public searchData(e) {
        e = e || window.event;
        const charCode = e.which || e.keyCode;
        if ((charCode < 16 || charCode > 20) && charCode != 27
            && (charCode < 33 || charCode > 40) && (charCode < 112 || charCode > 123)
            && (charCode != 144 || charCode != 145) && charCode != 45) {
            if (!this.checkBoxes) {
                this.selectedValue = null;
                this._onChange(this.selectedValue);
            }
            this.showPopupClick();
            if (this.serverFiltering) {
                this.textChanged.emit(e.target.value);
            } else {
                if (this.fullData) {
                    const _the = this;
                    this.data = this.fullData.filter(function (item) {
                        return item[_the.displayMember].toLowerCase().indexOf(e.target.value.toLowerCase()) > -1;
                    });
                }
            }
        }
    }

    public keypressed(e) {
        if (!this.disabled) {
            e = e || window.event;
            const charCode = e.charCode || e.which;
            if (charCode == 40) {
                this.setCurrent(false);
            } else if (charCode == 38) {
                this.setCurrent(true);
            }
        }
    }

    public setCurrent(isUp: boolean) {
        if (this.data) {
            if (this.data.length > 0) {
                if (!isUp) {
                    if (this.currentIndex != (this.data.length - 1)) {
                        this.currentIndex++;
                    }
                } else if (this.currentIndex > 0) {
                    this.currentIndex--;
                }
                const item = this.data[this.currentIndex];
                this.data.forEach(it => it.isCurrent = false);
                item.isCurrent = true;
                this.selectItem(item);
            }
        }
    }

    public itemClick(item) {
        if (!this.checkBoxes) {
            this.showPopup = false;
            this.selectItem(item);
        } else {
            if (item.checked) {
                item.checked = false;
            } else {
                item.checked = true;
            }
            this.chkClicked(item, null);
            this.selectedValue = this.getCheckedItemValues();
        }
    }
    public chkClicked(item, event) {
        if (event) {
            item.checked = event.target.checked;
            event.stopPropagation();
        }
        this.setCheckedItemText();
        this.selectedValue = this.getCheckedItemValues();
        this._onChange(this.selectedValue);
        this.itemCheckChanged.emit(item);
    }

    public getCheckedItems() {
        const items = this.fullData.filter(function (item) {
            return item.checked == true;
        });
        return items;
    }
    public getCheckedItemValues() {
        const items = this.getCheckedItems();
        const values = [];
        for (let i = 0; i < items.length; i++) {
            values.push(items[i][this.valueMember]);
        }
        return values;
    }

    public setCheckedItemText() {
        if (this.fullData) {
            this.itemText = '';
            const items = this.getCheckedItems();
            const text = [];
            if (items.length > 0) {
                if (items.length < 3) {
                    for (let i = 0; i < items.length; i++) {
                        text.push(items[i][this.displayMember]);
                    }
                    this.itemText = text.join(', ');
                } else {
                    this.itemText = items.length + ' ' + this.itemText + ' selected';
                }
            } else {
                this.itemText = '';
            }
        }
    }

    public selectItem(item) {
        this.selectedItemChanged.emit(item);

        this.itemText = item[this.displayMember];
        this.selectedValue = item[this.valueMember];
        this._onChange(this.selectedValue);
    }

    public closePopup(e) {
        if (!this.currentElement.nativeElement.contains(e.target)) {
            if (this.isTouched) {
                this.onTouchedCallback();
            }
            this.showPopup = false;
            if (this.checkBoxes && this.fullData) {
                this.setCheckedItemText();
            }
        }
    }

    public showPopupClick() {
        if (!this.disabled) {
            const width = jQuery(this.currentElement.nativeElement).find('div').width();
            this.width = (width - 4) + 'px';
            this.isTouched = true;
            this.showPopup = true;
        }
    }
}
